import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import { PageContentShell, TabbedPage, type TabbedPageTab } from "../../components/layout";
import { useUserRoles } from "../../hooks/useUserRoles";
import { isWorkspaceAdmin } from "../../utils/authorization";
import AdminDataAdaptorsPage from "../admin-data-adaptors/ui";
import IngestUploadPage from "../ingest/ui";
import AdminIngestPage from "../admin-ingest/ui";

/** Where data comes from: adaptors, file/API ingest and the rules (grants, PII, schemas) that govern ingest. */
const DataSources = () => {
  const { t } = useTranslation();
  const roles = useUserRoles();
  const canGovern = isWorkspaceAdmin(roles);
  const tabs = useMemo<TabbedPageTab[]>(
    () => [
      {
        key: "adaptors",
        label: t("nav.dataAdaptorsAdmin"),
        icon: <StorageOutlinedIcon fontSize="small" />,
        render: () => <AdminDataAdaptorsPage />,
      },
      {
        key: "ingest",
        label: t("nav.ingest"),
        icon: <UploadFileOutlinedIcon fontSize="small" />,
        render: () => <IngestUploadPage />,
      },
      {
        key: "governance",
        label: t("nav.ingestAdmin"),
        icon: <GavelOutlinedIcon fontSize="small" />,
        visible: canGovern,
        render: () => <AdminIngestPage />,
      },
    ],
    [t, canGovern]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PageContentShell>
        <TabbedPage title={t("nav.dataSources")} tabs={tabs} />
      </PageContentShell>
    </DashboardLayout>
  );
};

export default DataSources;
